<template>
  <vf-dialog-layout class="max-h-90dvh" :class-wrapper @close="emit('resolve')">
    <template #title>
      {{ $t.myAccount }}
    </template>
    <account-authentication @resolve="emit('resolve')" />
  </vf-dialog-layout>
</template>

<script lang="ts" setup>
import type { CSSClass } from '#types/common'

export type Props = {
  classWrapper?: CSSClass
}
export type Emits = {
  resolve: [v?: boolean]
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const { $t } = useNuxtApp()
</script>
